// extracted by mini-css-extract-plugin
var _1 = "webpack-components-layout-Stack-Stack-module__alignX-baseline";
var _2 = "webpack-components-layout-Stack-Stack-module__alignX-center";
var _3 = "webpack-components-layout-Stack-Stack-module__alignX-left";
var _4 = "webpack-components-layout-Stack-Stack-module__alignX-right";
var _5 = "webpack-components-layout-Stack-Stack-module__alignX-stretch";
var _6 = "webpack-components-layout-Stack-Stack-module__gap-0";
var _7 = "webpack-components-layout-Stack-Stack-module__gap-1";
var _8 = "webpack-components-layout-Stack-Stack-module__gap-10";
var _9 = "webpack-components-layout-Stack-Stack-module__gap-11";
var _a = "webpack-components-layout-Stack-Stack-module__gap-12";
var _b = "webpack-components-layout-Stack-Stack-module__gap-13";
var _c = "webpack-components-layout-Stack-Stack-module__gap-14";
var _d = "webpack-components-layout-Stack-Stack-module__gap-15";
var _e = "webpack-components-layout-Stack-Stack-module__gap-16";
var _f = "webpack-components-layout-Stack-Stack-module__gap-17";
var _10 = "webpack-components-layout-Stack-Stack-module__gap-18";
var _11 = "webpack-components-layout-Stack-Stack-module__gap-19";
var _12 = "webpack-components-layout-Stack-Stack-module__gap-2";
var _13 = "webpack-components-layout-Stack-Stack-module__gap-20";
var _14 = "webpack-components-layout-Stack-Stack-module__gap-3";
var _15 = "webpack-components-layout-Stack-Stack-module__gap-4";
var _16 = "webpack-components-layout-Stack-Stack-module__gap-5";
var _17 = "webpack-components-layout-Stack-Stack-module__gap-6";
var _18 = "webpack-components-layout-Stack-Stack-module__gap-7";
var _19 = "webpack-components-layout-Stack-Stack-module__gap-8";
var _1a = "webpack-components-layout-Stack-Stack-module__gap-9";
var _1b = "webpack-components-layout-Stack-Stack-module__wrapper";
export { _1 as "alignX-baseline", _2 as "alignX-center", _3 as "alignX-left", _4 as "alignX-right", _5 as "alignX-stretch", _6 as "gap-0", _7 as "gap-1", _8 as "gap-10", _9 as "gap-11", _a as "gap-12", _b as "gap-13", _c as "gap-14", _d as "gap-15", _e as "gap-16", _f as "gap-17", _10 as "gap-18", _11 as "gap-19", _12 as "gap-2", _13 as "gap-20", _14 as "gap-3", _15 as "gap-4", _16 as "gap-5", _17 as "gap-6", _18 as "gap-7", _19 as "gap-8", _1a as "gap-9", _1b as "wrapper" }
